// extracted by mini-css-extract-plugin
module.exports = {"brand-logo":"Navbar_brand-logo__2CtVk","button-container":"Navbar_button-container__sVVn0","btn-signup":"Navbar_btn-signup__3sYPQ"};